// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___lbjdf","productName":"productName___aAQJ_","date":"date___k_7h0"};